import languageCodes from './reddit-language-codes.json';

export interface MarketMetaResultFilters {
    publisher_platforms?: Array<'facebook' | 'instagram'>;
    languages?: string[];
    active_from?: string;
    active_to?: string;
    landing_domains?: string[];
    cta_texts?: string[];
}
export const isMetaCapability = (value: string) => ['meta.ads.discover_by_keyword', 'meta.ads.discover_by_advertiser'].includes(value);
const validDomain = (value: string) => value.length <= 253 && /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(value);

/** Keep canonical ordering stable for preview negotiation and normalize only known fields. */
export function normalizeMetaResultFilters(input: unknown): MarketMetaResultFilters {
    if (input == null) return {};
    if (typeof input !== 'object' || Array.isArray(input)) throw new Error('Invalid Meta result filters');
    const filters = input as Record<string, unknown>;
    if (Object.keys(filters).some(key => !['publisher_platforms', 'languages', 'active_from', 'active_to', 'landing_domains', 'cta_texts'].includes(key)))
        throw new Error('Unsupported Meta result filter');
    const result: MarketMetaResultFilters = {};
    for (const key of ['active_from', 'active_to'] as const) if (key in filters) {
        const value = filters[key];
        const date = typeof value === 'string' ? new Date(value + 'T00:00:00Z') : new Date(NaN);
        if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value) || !Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value)
            throw new Error('Invalid UTC active date');
        result[key] = value;
    }
    if (result.active_from && result.active_to && result.active_from > result.active_to) throw new Error('Invalid active range');
    for (const key of ['languages', 'publisher_platforms', 'landing_domains', 'cta_texts'] as const) if (key in filters) {
        const list = filters[key], max = key === 'languages' ? languageCodes.length : key === 'publisher_platforms' ? 2 : 20;
        if (!Array.isArray(list) || list.length > max || list.some(value => typeof value !== 'string')) throw new Error('Invalid Meta filter list');
        const values = [...new Set(list.map(value => key === 'cta_texts'
            ? value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase() : value.trim().toLowerCase()))].sort();
        if (values.some(value => key === 'languages' ? !languageCodes.includes(value) : key === 'publisher_platforms'
            ? !['facebook', 'instagram'].includes(value) : key === 'landing_domains' ? !validDomain(value) : !value || value.length > 120))
            throw new Error('Unsupported Meta filter value');
        if (values.length) Object.assign(result, { [key]: values });
    }
    return result;
}
